<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin" style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title>{{ title }}</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <q-file v-model="model.Files"
                                        label="Click to select file"
                                        dense
                                        accept=".xlsx, *.xls"
                                        @rejected="onRejected">
                                </q-file>
                            </div>
                            <div class="col-12">
                                <q-checkbox v-model="model.DeleteExistingRecords"
                                            label="Delete all existing SKU before import"
                                            dense>
                                </q-checkbox>
                            </div>
                        </div>
                    </div>
                </q-card-section>

                <q-card-actions align="right" class="bg-grey-2" v-if="editMode === true">
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick"></q-btn>
                </q-card-actions>
                <q-card-actions align="right" class="bg-grey-2" v-if="editMode === false">
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick"></q-btn>
                </q-card-actions>
            </q-form>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
</style>

<script>
    export { default } from './sku-map-trading-items-import-screen.js'
</script>